/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const GET_CHATGPT_GIFT_MESSAGE = 'mbp-checkout/GET_CHATGPT_GIFT_MESSAGE';
export const UPDATE_CHATGPT_GIFT_MESSAGE = 'MFE/CHECKOUT/UPDATE_CHATGPT_GIFT_MESSAGE';
export const UPDATE_SELECTED_CHATGPT_GIFT_MESSAGE = 'MFE/CHECKOUT/UPDATE_SELECTED_CHATGPT_GIFT_MESSAGE';
export const CLEAR_ALL_CHATGPT_GIFT_MESSAGE = 'MFE/CHECKOUT/CLEAR_ALL_CHATGPT_GIFT_MESSAGE';

export default {};
